import { NativeSelect } from "lib/miolo";
import type { MenuProvided } from "react-instantsearch-core";
import { connectMenu } from "react-instantsearch-dom";

const RealEstateFundMandateMenu = connectMenu<MenuProvided>(({ refine, currentRefinement }) => {
  return (
    <div className="space-y-4">
      <h3 className="font-aeonik text-base font-bold uppercase tracking-wide text-zinc-500">Mandato</h3>

      <NativeSelect value={currentRefinement || ""} onChange={(event) => refine(event.currentTarget.value || "")}>
        <option value="">Todos</option>
        <option value="Híbrido">Híbrido</option>
        <option value="Renda">Renda</option>
        <option value="Desenvolvimento para Renda">Desenvolvimento para Renda</option>
        <option value="Desenvolvimento para Venda">Desenvolvimento para Venda</option>
        <option value="Títulos e Valores Mobiliários">Títulos e Valores Mobiliários</option>
      </NativeSelect>
    </div>
  );
});

export default function RealEstateFundMandate() {
  return <RealEstateFundMandateMenu attribute="mandate" />;
}
